import React from 'react';
import { Container, Grid, Image } from 'semantic-ui-react';
import { PageTitle } from '../common/PageTitle';

export const ContentPartnership = () => {
  return (
    <React.Fragment>
      <PageTitle title='NATS Partnership' name='partnership' bgImg='/img/bridge.jpg'>
      </PageTitle>
      <Container className='content-main'>
        <p className='jumbotron'>
          We are thrilled to be connected with the <a
          href="https://www.nats.org/" target="_blank">National
          Association of Teachers of Singing</a>, which is championing
          this project through generous website hosting support. We
          extend our gratitude to NATS and its members for helping LSP
          live in perpetuity. 
        </p>
        <Grid columns={2} stackable>
          <Grid.Column textAlign='center' verticalAlign='middle'>
            <Image inline src='/img/nats-logo.png' className='nats-logo-page'/>   
          </Grid.Column>
          <Grid.Column>
            <p>
                Founded in 1944, National Association of Teachers of
                Singing, Inc. (NATS) is the largest professional association
                of teachers of singing in the world with more than 7,000
                members in the United States, Canada, and more than 35 other
                countries. Whether working in independent studios, community
                schools, elementary and secondary schools, or higher
                education, NATS members represent the diversity of today’s
                music landscape, teaching in all vocal styles.
              </p>
              <p>
                Internationally, NATS is represented in Argentina,
                Australia, Austria, Belgium, Bolivia, Brazil, China,
                Colombia, Denmark, France, Germany, Greece, Hungary,
                Indonesia, Ireland, Italy, Japan, Malaysia, Mexico,
                Netherlands, Portugal, Singapore, South Korea, Spain,
                Sweden, Switzerland, Taiwan, and the United Kingdom, with
                the number of countries growing every year.
              </p>
            </Grid.Column>
          </Grid>
      </Container>
    </React.Fragment>
  )
};